const { getApi } = require('../config/getApiUrl');
const homeUrl = getApi();

// ✅ FUNCIÓN HELPER PARA HEADERS (igual que adminVentasCompras.service.js)
const getAuthHeaders = () => {
  const token = localStorage.getItem('auth');

  if (!token) {
    throw new Error('No hay token de autenticación');
  }

  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export default {
  homeUrl,
  
  // ============================================
  // MÉTODOS DE USUARIO
  // ============================================
  
  async solicitarUsuario(parametros) {
    try {
      const url = `${homeUrl}${parametros}`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      return data[0].id_usuario;

    } catch (error) {
      console.error('Error al obtener usuario:', error);
      throw error;
    }
  },

  async solicitarUsuarioToken() {
    try {
      const url = `${homeUrl}/usuarios`;
      const headers = getAuthHeaders();

      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const userData = await response.json();
      const id_usuario = userData.id_usuario;

      if (!id_usuario) {
        throw new Error('No se pudo obtener el ID del usuario');
      }

      return id_usuario;
    } catch (error) {
      console.error('Error al obtener los datos del usuario:', error);
      
      if (error.message.includes('401')) {
        localStorage.removeItem('auth');
        window.location.href = '/login';
      }
      
      throw error;
    }
  },

  // ============================================
  // MÉTODOS GENERALES (SIN AUTH)
  // ============================================

  async fetchRegistros(parametros) {
    try {
      const url = `${homeUrl}${parametros}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      return data;

    } catch (error) {
      console.error('Error al obtener registros:', error);
      throw error;
    }
  },

  async fetchEstadoRegistros(parametros) {
    try {
      const url = `${homeUrl}${parametros}`;
      const response = await fetch(url);
      
      return response;

    } catch (error) {
      console.error('Error al obtener registros:', error);
      throw error;
    }
  },

  async patchRegistro(parametros, datosActualizados) {
    try {
      const url = `${homeUrl}${parametros}`;
      const respuesta = await fetch(`${url}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datosActualizados)
      });

      if (!respuesta.ok) {
        throw new Error(`No se pudo actualizar: ${respuesta.statusText}`);
      }

      return respuesta.ok;
    } catch (error) {
      throw new Error(`Ocurrio un error: ${error}`);
    }
  },

  async patchRegistroProducto(parametros, datosActualizados) {
    try {
      const url = `${homeUrl}${parametros}`;
      const respuesta = await fetch(`${url}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datosActualizados)
      });

      if (!respuesta.ok) {
        throw new Error(`No se pudo actualizar: ${respuesta.statusText}`);
      }

      return respuesta.json();
    } catch (error) {
      throw new Error(`Ocurrio un error: ${error}`);
    }
  },

  async agregarProductoLista(parametros, datosActualizados) {
    try {
      const url = `${homeUrl}${parametros}`;
      const respuesta = await fetch(`${url}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datosActualizados)
      });

      return respuesta.json();
    } catch (error) {
      throw new Error(`Ocurrio un error: ${error}`);
    }
  },

  async desactivarRegistro(parametros, datosActualizados) {
    try {
      const url = `${homeUrl}${parametros}`;
      const respuesta = await fetch(`${url}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datosActualizados)
      });

      if (!respuesta.ok) {
        throw new Error(`No se pudo actualizar: ${respuesta.statusText}`);
      }

      return respuesta.ok;
    } catch (error) {
      throw new Error(`Ocurrio un error: ${error.statusText}`);
    }
  },

  async postRegistro(parametros, datosNuevos) {
    const url = `${homeUrl}${parametros}`;
    try {
      const respuesta = await fetch(`${url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datosNuevos)
      });
      
      if (!respuesta.ok) {
        throw new Error(`No se pudo crear: ${respuesta.statusText}`);
      }
      
      const nuevoRegistro = await respuesta.json();
      return nuevoRegistro;
      
    } catch (error) {
      throw new Error(`Ocurrio un error: ${error.message}`);
    }
  },

  async deleteRegistro(parametros) {
    const url = `${homeUrl}${parametros}`;
    try {
      const response = await fetch(url, { method: 'DELETE' });

      if (response.ok) {
        return true;
      } else {
        throw new Error('No se elimino el registro ' + response.status);
      }

    } catch (error) {
      console.log(error);
      return error;
    }
  },

  // ============================================
  // MÉTODOS PARA REPORTES DE VENTAS (CON AUTH)
  // ============================================

  async obtenerReporteVentas(filtros) {
    try {
      const headers = getAuthHeaders();
      const queryParams = new URLSearchParams({
        tipo_reporte: filtros.reporteSeleccionado,
        fecha_inicio: filtros.fechaInicio,
        fecha_fin: filtros.fechaFin,
        ...(filtros.valorFiltro && { 
          [`id_${filtros.reporteSeleccionado.split('_')[1]}`]: filtros.valorFiltro 
        })
      }).toString();

      const url = `${homeUrl}/reporte/reporte?${queryParams}`;
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener reporte:', error);
      throw error;
    }
  },

  async obtenerClientesReporte() {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}/reporte/clientes`;
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener clientes:', error);
      throw error;
    }
  },

  async obtenerSucursalesReporte() {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}/reporte/sucursales`;
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener sucursales:', error);
      throw error;
    }
  },

  async obtenerEmpleadosReporte() {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}/reporte/empleados`;
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener empleados:', error);
      throw error;
    }
  },

  // ============================================
  // MÉTODOS PARA REPORTES DE COMPRAS (CON AUTH)
  // ============================================

  /**
   * ✅ CORRECCIÓN: Obtener reporte general de compras
   */
  async obtenerReporteCompras(id_usuario, fechaInicio, fechaFin, limite = 50, id_sucursal = null) {
    try {
      const headers = getAuthHeaders();
      
      // ✅ Construir query params
      const params = new URLSearchParams({
        limite: limite.toString()
      });
      
      if (id_sucursal) {
        params.append('id_sucursal', id_sucursal);
      }
      
      const url = `${homeUrl}/reporte/compras/${id_usuario}/${fechaInicio}/${fechaFin}?${params}`;
      
      console.log('🔍 URL de compras:', url);
      
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('❌ Error al obtener reporte de compras:', error);
      throw error;
    }
  },

  /**
   * Obtener compras agrupadas por proveedor
   */
  async obtenerComprasPorProveedor(id_usuario, fechaInicio, fechaFin, limite = 50) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}/reporte/compras/por-proveedor/${id_usuario}/${fechaInicio}/${fechaFin}?limite=${limite}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener compras por proveedor:', error);
      throw error;
    }
  },

  /**
   * Obtener compras agrupadas por sucursal (solo CEO)
   */
  async obtenerComprasPorSucursal(id_usuario, fechaInicio, fechaFin, limite = 50) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}/reporte/compras/por-sucursal/${id_usuario}/${fechaInicio}/${fechaFin}?limite=${limite}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener compras por sucursal:', error);
      throw error;
    }
  },

  /**
   * Obtener desglose de compras de un proveedor específico
   */
  async obtenerComprasProveedorDesglose(id_proveedor, fechaInicio, fechaFin, limite = 100) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}/reporte/compras/proveedor-desglose/${id_proveedor}/${fechaInicio}/${fechaFin}?limite=${limite}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener desglose de proveedor:', error);
      throw error;
    }
  },

  /**
   * Obtener desglose de compras de una sucursal específica
   */
  async obtenerComprasSucursalDesglose(id_sucursal, fechaInicio, fechaFin, limite = 200) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}/reporte/compras/sucursal-desglose/${id_sucursal}/${fechaInicio}/${fechaFin}?limite=${limite}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener desglose de sucursal:', error);
      throw error;
    }
  },

  /**
   * Obtener lista de proveedores para filtros en reportes
   */
  async obtenerProveedoresReporte() {
    try {
      const headers = getAuthHeaders();
      const id_usuario = await this.solicitarUsuarioToken();
      const url = `${homeUrl}/reporte/compras/proveedores/${id_usuario}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener proveedores:', error);
      throw error;
    }
  },

  // ============================================
  // ✅ REPORTE FISCAL DE VENTAS
  // ============================================

  /**
   * ✅ CORRECCIÓN: Obtener reporte fiscal de ventas
   */
  async obtenerReporteFiscalVentas(id_usuario, fechaInicio, fechaFin, limite = 1000, id_sucursal = null) {
    try {
      const headers = getAuthHeaders();
      
      // ✅ Construir query params
      const params = new URLSearchParams({
        limite: limite.toString()
      });
      
      if (id_sucursal) {
        params.append('id_sucursal', id_sucursal);
      }
      
      const url = `${homeUrl}/reporte/ventas-fiscales/${id_usuario}/${fechaInicio}/${fechaFin}?${params}`;
      
      console.log('🔍 URL de reporte fiscal:', url);
      
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('❌ Error al obtener reporte fiscal de ventas:', error);
      throw error;
    }
  },

  // ============================================
  // MÉTODOS CON AUTENTICACIÓN
  // ============================================

  async fetchRegistrosAuth(parametros) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}${parametros}`;

      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (response.status === 401) {
        localStorage.removeItem('auth');
        window.location.href = '/login';
        throw new Error('Sesión expirada');
      }

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      return data;

    } catch (error) {
      console.error('Error al obtener registros autenticados:', error);
      throw error;
    }
  },

  async postRegistroAuth(parametros, datosNuevos) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}${parametros}`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(datosNuevos)
      });
      
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      return data;

    } catch (error) {
      console.error('Error al crear registro autenticado:', error);
      throw error;
    }
  },

  async patchRegistroAuth(parametros, datosActualizados) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}${parametros}`;
      
      const response = await fetch(url, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(datosActualizados)
      });
      
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return response.ok;

    } catch (error) {
      console.error('Error al actualizar registro autenticado:', error);
      throw error;
    }
  },

  async desactivarRegistroAuth(parametros, datosActualizados) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}${parametros}`;
      const respuesta = await fetch(url, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(datosActualizados)
      });

      if (!respuesta.ok) {
        throw new Error(`No se pudo actualizar: ${respuesta.statusText}`);
      }

      return respuesta.ok;
    } catch (error) {
      throw new Error(`Ocurrio un error: ${error.statusText || error.message}`);
    }
  },

  async patchRegistroProductoAuth(parametros, datosActualizados) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}${parametros}`;
      const respuesta = await fetch(url, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(datosActualizados)
      });

      if (!respuesta.ok) {
        throw new Error(`No se pudo actualizar: ${respuesta.statusText}`);
      }

      return respuesta.json();
    } catch (error) {
      throw new Error(`Ocurrio un error: ${error}`);
    }
  },

  async agregarProductoListaAuth(parametros, datosActualizados) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}${parametros}`;
      const respuesta = await fetch(url, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(datosActualizados)
      });

      return respuesta.json();
    } catch (error) {
      throw new Error(`Ocurrio un error: ${error}`);
    }
  },

  async deleteRegistroAuth(parametros) {
    try {
      const headers = getAuthHeaders();
      const url = `${homeUrl}${parametros}`;
      
      const response = await fetch(url, {
        method: 'DELETE',
        headers
      });
      
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return true;

    } catch (error) {
      console.error('Error al eliminar registro autenticado:', error);
      throw error;
    }
  },

  /**
 * ✅ NUEVO: Obtener facturas sin SAR (facturas temporales/inválidas)
 */
async obtenerFacturasSinSAR(id_usuario, fechaInicio, fechaFin, limite = 100, id_sucursal = null) {
  try {
    const headers = getAuthHeaders();
    
    const params = new URLSearchParams({
      limite: limite.toString()
    });
    
    if (id_sucursal) {
      params.append('id_sucursal', id_sucursal);
    }
    
    const url = `${homeUrl}/reporte/facturas-sin-sar/${id_usuario}/${fechaInicio}/${fechaFin}?${params}`;
    
    console.log('🔍 URL de facturas sin SAR:', url);
    
    const response = await fetch(url, {
      method: 'GET',
      headers
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('❌ Error al obtener facturas sin SAR:', error);
    throw error;
  }
},

};